import axios from "axios";

export const staffApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/staff`, withCredentials: true });

staffApi.interceptors.response.use(null, async (err) => {
  const cfg = err.config;
  if (err.response?.status === 401 && !cfg._retried && !["/login", "/refresh"].includes(cfg.url)) {
    cfg._retried = true;
    await staffApi.post("/refresh");
    return staffApi(cfg);
  }
  throw err;
});

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "連線失敗，請重新整理頁面後再試";
  if (!d) return "發生錯誤，請再試一次";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return String(d.msg || d);
};
